import React, { Component, Fragment } from "react";

class Header extends Component {
  state = {
    control: null,
    loaded: false,
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.setState({
      control: this.props.control,
      loaded: true,
    });
  }

  render() {
    if (this.state.loaded) {
      return (
        <div className="header">
          <div className="hold">
            <a href="/" className="logo addCursorPointer"></a>
            <a href="/" className="refresh"></a>
          </div>
        </div>
      );
    } else {
      return "";
    }
  }
}

export default Header;
